module.exports = __webpack_public_path__ + "img/305.d62b5e1f.jpg";